import React from 'react';
import style from './Loading.module.css';
import { useSelector } from "react-redux";
import { Loadingstate } from '@/app/store/store';
const Loading =()=>{
    const loading = useSelector((state:Loadingstate)=>state.loading);
    return(
        <div className={`${style.loadingcontainer} col-12 ${loading.visible?'d-flex':'d-none'} justify-content-center align-items-center`}>
            <div className={`${style.loadingContent} d-flex align-items-center flex-column`}>
                <div className={`${style.loadingmessage}`}>
                    <span>{loading.message||"Loading ..."}</span>
                </div>
                <div className={`${style.loading}`}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
        </div>
    )
}

export default Loading;